// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class MarkupData {
    constructor(typeId, formula, markups, useMarkupInUnrealizedPnl = true) {
        this.TypeId = typeId;
        this.Formula = formula;
        this.Markups = markups;
        this.UseMarkupInUnrealizedPnl = useMarkupInUnrealizedPnl;
    }
    toString() {
        return this.TypeId.toString();
    }
}
